import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';
import { ContextMenuTrigger } from 'react-contextmenu';
import classNames from 'classnames';

import config from '../../../../config';
import Input from '../../../helpers/Input';
import { getIn } from '../../../../utils/ChangeSpy';

import style from './style.module.css';

/**
 * Column of one row table component.
 *
 * @param props {Object}.
 * @param props.row {Immutable.Map} Row Object.
 * @param props.contextId {String} Context menu's id.
 * @param props.type {String} Use type to differentiate which tables are firing events.
 * @param props.onTextChange {Function} Handle event of changing text.
 * @param props.onRowClick {Function} Handle event of clicking on a row.
 * @param props.onKeyPress {Function} Handle event of key pressing.
 */
const HarvcoTagTableRowComponent = ({
  row,
  type,
  contextId,
  onTextChange,
  onRowClick,
  setInputElement,
  onKeyPress,
}) => {
  const id = row.get('id');
  const mode = row.get('mode');
  const cellClass = classNames(style.cell, {
    [style.cellMarked]: row.get('dirty'),
  });

  if (mode === config.EDIT_MODE) {
    return (
      <tr>
        <td className={style.cell} onClick={event => event.stopPropagation()}>
          <Input
            className="form-control"
            id={`input_${type}${id}`}
            inputRef={setInputElement}
            name="tag"
            onChange={event => onTextChange({ event, data: { type, row } })}
            onKeyPress={event => onKeyPress({ event, row })}
            placeholder="HarcCo Tag"
            showLabel={false}
            value={getIn(row, 'tag')}
          />
        </td>
      </tr>
    );
  }

  return (
    <ContextMenuTrigger collect={() => ({ id, type })} id={contextId} renderTag="tr">
      <td
        className={cellClass}
        onClick={event => {
          event.stopPropagation();
          onRowClick({ row, type });
        }}
      >
        {getIn(row, 'tag')}
      </td>
    </ContextMenuTrigger>
  );
};

HarvcoTagTableRowComponent.propTypes = {
  contextId: PropTypes.string.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  row: PropTypes.instanceOf(Map).isRequired,
  setInputElement: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export const HarvcoTagTableRow = memo(HarvcoTagTableRowComponent);
